import React from 'react';

export function TypingIndicator() {
  return (
    <div className="flex items-end gap-2 animate-fade-in">
      {/* Avatar */}
      <div className="w-8 h-8 rounded-full bg-brand-surface-2 border border-white/10 flex items-center justify-center shrink-0">
        <span className="text-xs text-brand-gray-light font-semibold">S</span>
      </div>

      <div className="message-bubble-stranger !py-3 !px-4 flex items-center gap-1.5">
        <span className="typing-dot" />
        <span className="typing-dot" style={{ animationDelay: '0.2s' }} />
        <span className="typing-dot" style={{ animationDelay: '0.4s' }} />
      </div>
    </div>
  );
}
